import { Component, OnInit } from '@angular/core';
import { NotyService } from '../../../services/common/noty.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NewsletterFooterService } from '../../../services/newsletters/newsletter-footer.service';

@Component({
  selector: 'app-newsletter-footer-form',
  templateUrl: './newsletter-footer-form.component.html',
  styleUrls: ['./newsletter-footer-form.component.scss'],
})
export class NewsletterFooterFormComponent implements OnInit {
  name: string = '';
  htmlContent: string = '';
  newsletterFooterId: string = '';
  isSubmitting: Boolean = false;

  constructor(private newsletterFooterService: NewsletterFooterService, private route: ActivatedRoute, private notyService: NotyService, private router: Router) {}

  ngOnInit() {
    if (this.route.snapshot.params['id']) {
      this.newsletterFooterId = this.route.snapshot.params['id'];
      console.log(this.route.snapshot.params['id']);
      this.newsletterFooterService
        .show({ angular: true, newsletterFooterId: this.newsletterFooterId })
        .then((showRe) => {
          console.log('showRe', showRe);
          this.name = showRe.name;
          this.htmlContent = showRe.html_content;
        })
        .catch((showErr) => {
          console.log('show error', showErr);
        });
    }
  }

  createNewsletterFooter = () => {
    if (this.name && this.htmlContent) {
      this.isSubmitting = true;
      this.newsletterFooterService
        .create({ name: this.name, footer_html: this.htmlContent })
        .then((createNewsletterFooterRe) => {
          console.log('createNewsletterFooter', createNewsletterFooterRe);
          this.notyService.notify('Created Newsletter Footer', 'success');
          this.isSubmitting = false;
          this.router.navigateByUrl('/newsletter_footers');
        })
        .catch((err) => {
          console.log('createStyleSheet error', err);
        });
    } else {
      this.notyService.notify('Both Name and HTML Content fields are mandatory', 'error');
    }
  };

  updateNewsletterFooter = () => {
    if (this.name && this.htmlContent) {
      this.isSubmitting = true;
      this.newsletterFooterService
        .update({ angular: true, name: this.name, footer_html: this.htmlContent, newsletterFooterId: this.newsletterFooterId })
        .then((updateNewsletterFooterRe) => {
          console.log('updateNewsletterFooterRe', updateNewsletterFooterRe);
          this.notyService.notify('Newsletter Footer Updated', 'success');
          this.router.navigateByUrl('/newsletter_footers');
        })
        .catch((updateNewsletterFooterEr) => {
          console.log('updateNewsletterFooterEr', updateNewsletterFooterEr);
        });
    } else {
      this.notyService.notify('Both Name and HTML Content fields are mandatory', 'error');
    }
  };
}
